
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
const ComponentsBreadcrumb = (props) => {
  const extraBreadcrumbItems = props.breadCrumbList?.map((name, index) => {
      return (
        <Breadcrumb.Item key={name.url}>
       <Link to={name.url}>{name.bname}</Link>
        </Breadcrumb.Item>
        
      );
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="/dashboard"></Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (<>
      <Breadcrumb  className='mb-26 cust-breadcrumb' separator={<span className='icon sm bc-arrow' />}>{breadcrumbItems}</Breadcrumb>
  </>)
}

export default ComponentsBreadcrumb;